// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {AppIdsEnum, AvailableLangs, EnvironmentInterface, EnvsEnum} from './environment.interface';

export const environment: EnvironmentInterface = {
	name: EnvsEnum.testing,
	baseUrl: '',
	defaultLang: AvailableLangs.da,
	storagePrefix: 'egcc',
	production: false,
	apiUrl: 'https://apitest.cliniccare.dk',
	mockApi: 'https://egcc-mock.azurewebsites.net',
	appId: AppIdsEnum.testing
};

